import React, { Fragment, lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";

let emailSignupOG = "https://contentgenerator.io/emailSignupOG.webp";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
const EmailSignup = lazy(() =>
  import(
    /* webpackChunkName: "EmailSignup" */ "../components/EmailSignup/EmailSignup"
  )
);

// Redux stuff
import { connect } from "react-redux";

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
}));

function emailSignup(props) {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Newsletter Signup - Content Generator`}
        description={`Subscribe to our weekly social media marketing newsletter for the latest tips, strategies, and insights to grow your business. Get expert advice on post design, SEO, analytics, and automation delivered straight to your inbox.`}
        ogImage={emailSignupOG}
        url={`https://contentgenerator.io/email-signup`}
      />
      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          <EmailSignup />
        </Suspense>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI,
});

export default connect(mapStateToProps)(emailSignup);
